import React, { useState } from 'react'
import { SignIn, SignUp } from '@clerk/clerk-react'
import { useUI } from '../../contexts/UIContext'

const AuthModal: React.FC = () => {
  const { authModalOpen, closeAuthModal } = useUI()
  const [mode, setMode] = useState<'sign-in' | 'sign-up'>('sign-in')

  const isOpen = authModalOpen

  const handleClose = () => {
    closeAuthModal()
  }

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) handleClose()
  }

  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50"
      onClick={handleOverlayClick}
    >
      <div className="relative">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute -top-3 -right-3 z-10 bg-white dark:bg-neutral-700 rounded-full p-1.5 shadow-md text-neutral-500 hover:text-neutral-800 dark:hover:text-white transition-colors"
          aria-label="Close"
        >
          <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {mode === 'sign-in' ? (
          <SignIn
            afterSignInUrl={window.location.href}
            afterSignUpUrl={window.location.href}
            appearance={{
              elements: {
                rootBox: 'shadow-xl rounded-xl overflow-hidden',
                card: 'shadow-none',
              },
            }}
            fallbackRedirectUrl={window.location.href}
          />
        ) : (
          <SignUp
            afterSignUpUrl={window.location.href}
            afterSignInUrl={window.location.href}
            appearance={{
              elements: {
                rootBox: 'shadow-xl rounded-xl overflow-hidden',
                card: 'shadow-none',
              },
            }}
          />
        )}

        {/* Toggle link */}
        <div className="text-center mt-2 text-sm text-neutral-600 dark:text-neutral-400">
          {mode === 'sign-in' ? (
            <>
              Don&apos;t have an account?{' '}
              <button
                onClick={() => setMode('sign-up')}
                className="text-primary-600 hover:underline font-medium"
              >
                Sign up
              </button>
            </>
          ) : (
            <>
              Already have an account?{' '}
              <button
                onClick={() => setMode('sign-in')}
                className="text-primary-600 hover:underline font-medium"
              >
                Sign in
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default AuthModal
